// extracted by mini-css-extract-plugin
export default {"formbox":"EmailTxt_formbox__-5mrs","form":"EmailTxt_form__XRd3x","btn":"EmailTxt_btn__Ja6iR","btnDisabled":"EmailTxt_btnDisabled__IQ4M7"};